<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZkE8rg/tc-custom/9781467463386.jpg?1731055222016" alt="This image is the cover for the book Discovering Psalms, Discovering Biblical Texts (DBT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Discovering Psalms, Discovering Biblical Texts (DBT)
      </h1>
      <p class="bookDescription body article font2">
        <p>This compact introduction to the interpretation of the book of Psalms encourages in-depth study of the text and genuine grappling with related theological and historical questions by providing a critical assessment of key interpreters and interpretative debates. It draws on a range of methodological approaches (author-, text-, and reader-centered) and reflects the growing scholarly attention to the reception history of biblical texts, increasingly viewed as a vital aspect of interpretation rather than an optional extra.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jerome F D Creach
      </h2>
      
      <p class="authorDescription body article"><B>Jerome F. D. Creach</B>&#160;is the Robert C. Holland Professor of Old Testament at Pittsburgh Theological Seminary.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?57e8c0d7